import { format } from 'owa-strings/utilities/format';

/**
 * Given a count, selects the appropriate string based on the count
 * @param count
 * @param singularString
 * @param dualString
 * @param pluralString
 * @param noCountString
 */
export const selectStringForCount = (
    count: number,
    singularString: string,
    dualString: string,
    pluralString: string,
    noCountString: string = '',
    ...rest: any[]
): string => {
    if (!count) {
        return format(noCountString, ...rest);
    }

    switch (count) {
        case 1:
            return format(singularString, ...rest);
        case 2:
            return format(dualString, ...rest);
    }

    return format(pluralString, count, ...rest);
};
